import { render, staticRenderFns } from "./Reseau.vue?vue&type=template&id=88894a54"
import script from "./Reseau.vue?vue&type=script&lang=js"
export * from "./Reseau.vue?vue&type=script&lang=js"
import style0 from "./Reseau.vue?vue&type=style&index=0&id=88894a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports